export default __webpack_public_path__ + "static/media/myclassroom_logo.7b93fa10.svg";